module.exports = __webpack_public_path__ + "img/87.3.TP.6a2f5a00.png";